import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getInfrastructureTags: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS,
	},
	getInfrastructureTagsPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS_PREVIEW,
	},
	createInfrastructureTags: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].CREATE_INFRASTRUCTURE_TAGS,
	},
	getInfrastructureTag: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAG,
	},
	patchInfrastructureTags: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PATCH_INFRASTRUCTURE_TAGS,
	},
	putInfrastructureTags: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PUT_INFRASTRUCTURE_TAGS,
	},
	deleteInfrastructureTags: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].DELETE_INFRASTRUCTURE_TAGS,
	},
}